/**
 * Service pour réaliser les appels à l'api personne client.
 */
import { LncBaseApiClientService } from './lnc-base-api-client.service';

/**
 *
 * @type {{PROFESSIONNEL: string, COLLECTIVITE: string, ENTREPRISE: string, PARTICULIER: string}}
 */
const LNC_ESPACE = {
  PROFESSIONNEL: 'PROFESSIONNEL',
  PARTICULIER: 'PARTICULIER',
  ENTREPRISE: 'ENTREPRISE',
  COLLECTIVITE: 'COLLECTIVITE',
};

class LncMonCompteClientService extends LncBaseApiClientService {
  /**
   * Initialise une instance de type {@type ApiClientMonCompteLincs}.
   * @param baseUrl {string} L'url du serveur de l'api.
   * @param espace {string} L'espace de connexion dont la valeur est contenue dans le type {@type LNC_ESPACE}.
   */
  constructor(baseUrl, espace) {
    super(baseUrl);
    this.espace = espace;
  }

  /**
   * Action pour récupérer les informations de connexion.
   * @returns {Promise<UserInfoV2Dto>} La promesse d'une réponse.
   */
  getUserInfosV1() {
    return new Promise((resolve, reject) => {
      this.get(`/api/private/v1/userinfos?espace=${this.espace}`)
        .then(response => {
          resolve({
            cnAlex: response.content.userProperties.av2_interne_id,
          });
        })
        .catch(() => {
          reject();
        });
    });
  }

  /**
   * Action pour récupérer les informations de la personne.
   * @returns {Promise<UserInfoV2Dto>} La promesse d'une réponse.
   */
  getUserInfosV2() {
    return new Promise((resolve, reject) => {
      this.get(`/api/private/v2/userinfos?espace=${this.espace}`)
        .then(response => {
          // Transformer dateCGU en objet date
          const rawDateCGU = response.content.espacesAssocies[0].dateCgu;
          response.content.dateCGU = rawDateCGU ? new Date(rawDateCGU) : null;

          resolve(response.content);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  /**
   * Action pour persister la date des CGU.

   * @param cnAlex {string} L'identifiant alex de la personne.
   * @param dateCgu {date} Date des conditions générales d'utilisation

   * @returns {Promise<bool>} La promesse d'une réponse.
   */
  postDateCgu(cnAlex, dateCgu) {
    return this.postDateCguWithEspace(cnAlex, dateCgu, 'ENTREPRISE');
  }

  /**
   * Action pour persister la date des CGU avec envoi de l'espace.

   * @param cnAlex {string} L'identifiant alex de la personne.
   * @param dateCgu {date} Date des conditions générales d'utilisation
   * @param espaceCompte {string} Espace du compte

   * @returns {Promise<bool>} La promesse d'une réponse.
   */
  postDateCguWithEspace(cnAlex, dateCgu, espaceCompte) {
    const dateToSend =
      dateCgu.getFullYear() +
      '-' +
      ('0' + (dateCgu.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + dateCgu.getDate()).slice(-2);

    const data = {
      espace: espaceCompte,
      dateCGU: dateToSend,
    };

    return new Promise((resolve, reject) => {
      this.post('/api/private/v1/personnes/' + cnAlex + '/datecgu', data)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    });
  }

  /**
   * Action pour récupérer le périmètre de la personne.
   * @param cnAlex {string} L'identifiant alex de la personne.
   * @returns {Promise<PerimetreDto[]>} La promesse d'une réponse.
   */
  getPerimetre(cnAlex) {
    return new Promise((resolve, reject) => {
      this.get('/api/private/v1/personnes/' + cnAlex + '/perimetre')
        .then(response => {
          if (response.status === 204) {
            resolve([]);
          } else {
            resolve(response.content.habilitations);
          }
        })
        .catch(() => {
          reject();
        });
    });
  }
}

export { LncMonCompteClientService, LNC_ESPACE };
